import { render, staticRenderFns } from "./FormAlertsContent.vue?vue&type=template&id=1ef5f87c&scoped=true"
import script from "./FormAlertsContent.vue?vue&type=script&lang=js"
export * from "./FormAlertsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef5f87c",
  null
  
)

export default component.exports